







































































































































































































































































import Vue from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldTextArea from '@/components/form/FieldTextArea.vue';
// TODO: Будет добавлено позже
// import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
// import FieldSelect from '@/components/form/FieldSelect.vue';
// import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import { DropdownList, EBudgetType } from '@/types';

export default Vue.extend({
  name: 'SettingsTab',
  components: {
    FieldInput,
    FieldTextArea,
    // FieldDatePicker,
    // FieldSelect,
    // FieldCheckbox,
    WidgetWrapper,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },

  computed: {
    timeZone(): Array<DropdownList> {
      return this.$store.getters.getTimezoneList;
    },
    budgetType(): Array<DropdownList> {
      return [
        {
          label: 'Monetary Budget',
          value: EBudgetType.MONETARY_BUDGET,
        },
        {
          label: 'Impressions',
          value: EBudgetType.IMPRESSIONS,
        },
        {
          label: 'Clicks',
          value: EBudgetType.CLICKS,
        },
      ];
    },
    datePeriod(): Array<string> {
      if (this.group.startDate && this.group.endDate) {
        return [this.group.startDate, this.group.endDate];
      }
      return [];
    },
  },

  methods: {
    changeErrors() {},

    changeGroup(name, value) {
      this.$emit('changeGroup', { name, value });
    },

    changeDate(dateValue) {
      const [startDate, endDate] = dateValue;

      this.changeGroup('startDate', startDate);
      this.changeGroup('endDate', endDate);
    },
  },
});
